/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface PostDirectId201Response
 */
export interface PostDirectId201Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostDirectId201Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostDirectId201Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof PostDirectId201Response
     */
    result?: string;
}

/**
 * Check if a given object implements the PostDirectId201Response interface.
 */
export function instanceOfPostDirectId201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostDirectId201ResponseFromJSON(json: any): PostDirectId201Response {
    return PostDirectId201ResponseFromJSONTyped(json, false);
}

export function PostDirectId201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDirectId201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function PostDirectId201ResponseToJSON(value?: PostDirectId201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

